export default function genSrcSet(paths: string[]): string {
    return paths
        .reduce((result, path, index) => {
            result += `${path} ${index + 1}x,`;

            return result;
        }, '')
        .slice(0, -1);
}
